import {
  ADMIN_SETTINGS_RECEIVED
} from './types'

export default function settings(state = {}, action = {}){
  switch (action.type) {
    case ADMIN_SETTINGS_RECEIVED:
      return {
        ...state,
        ...action.settings
      }
    default:
      return state
  }
}